export default __webpack_public_path__ + "static/media/dialogs.f901175b.jpg";